import { render, staticRenderFns } from "./ShowcaseProduct.vue?vue&type=template&id=2bfaf7a2&scoped=true"
import script from "./ShowcaseProduct.vue?vue&type=script&lang=js"
export * from "./ShowcaseProduct.vue?vue&type=script&lang=js"
import style0 from "./ShowcaseProduct.vue?vue&type=style&index=0&id=2bfaf7a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bfaf7a2",
  null
  
)

export default component.exports